import { useEffect } from "react";
import {
  Item,
  TabList,
  TabPanels,
  Tabs,
  View,
  Text,
  StatusLight,
} from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import storeRTK from "../../../store/storeRTK";
import { setSelectedTab } from "../../../actions/common";
import "./index.css";
import { RootState } from "../../../store";
import { JSX } from "react";
import { HELPSUPPORT, LIVE_CASE, MY_NOTES, SETTINGS, SPEED_DIAL } from "../../../constants/constants";

interface Tab {
  name: string;
  children: JSX.Element;
}

interface TabSwitchProps {
  tabs: Tab[];
  history?: any[];
  isActiveChannel?: string;
}

const tabMapping: Record<string, string> = {
  call: "Call",
  callback: "Callback",
  voicemail: "Voicemail",
  chat: "Chats",
  [SETTINGS]: "Audio Settings",
  case: LIVE_CASE,
  [HELPSUPPORT]: "Help & Support",
  [SPEED_DIAL]: "Speed Dial",
  [MY_NOTES]: "Notes",
};

const TabSwitch = ({ tabs, history, isActiveChannel }: TabSwitchProps) => {
  const common = useSelector((state: RootState) => state.common);
  const session = useSelector((state: RootState) => state.session);

  const handleTabChange = (value: any) => {
    storeRTK.dispatch(setSelectedTab(value));
  };

  useEffect(() => {
    const selectedTab = tabMapping[session.currentTab];
    if (selectedTab) {
      storeRTK.dispatch(setSelectedTab(selectedTab));
    } else {
      storeRTK.dispatch(setSelectedTab(tabs[0].name));
    }
  }, []);

  const renderHistoryCount = () => {
    const count = history?.length;

    if (count && count > 0) {
      return (
        <div>
          <span className="tab-switch-count">{count}</span>
        </div>
      );
    }

    return null;
  };

  return (
    <View flexGrow={1} backgroundColor="static-white" height={"100%"}>
      <Tabs
        selectedKey={common.tab || ""}
        onSelectionChange={handleTabChange}
        height={"100%"}
        aria-label="Tab switch"
        data-testid="tab-switch"
      >
        <TabList UNSAFE_className="tab-item">
          {tabs.map((tab) => (
            <Item
              key={tab.name}
              textValue={tab.name}
              aria-label="tab heading"
              data-testid="tab-heading"
            >
              <Text UNSAFE_className="tab-item-label">{tab.name}</Text>
              <div className="tab-switch-container">
                {["Call", "Callback", "Voicemail", LIVE_CASE, "Chat"].includes(
                  tab.name
                ) &&
                  isActiveChannel && (
                    <StatusLight
                      role="status"
                      variant="negative"
                      UNSAFE_className="call-status-light"
                      aria-label="Call status light"
                    />
                  )}
                {tab.name === "History" && renderHistoryCount()}
              </div>
            </Item>
          ))}
        </TabList>
        <TabPanels UNSAFE_style={{ border: "0" }} height={"85%"}>
          {tabs.map((tab) => (
            <Item key={tab.name} aria-label="tab item" data-testid="tab-panel">
              {tab.children}
            </Item>
          ))}
        </TabPanels>
      </Tabs>
    </View>
  );
};

export default TabSwitch;
